module.exports = __webpack_public_path__ + "static/media/icon-edit.4eb0b567.svg";